import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Optional, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Utils from '@shared/core/utils';

@Component({
    template: '<div>This component requires extending</div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TilesComponent {
    public isLocked: boolean = false;
    public isHovering: boolean = false;

    @Input() public loading: boolean = false;

    constructor(
        @Optional() public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) { }

    public get isMobile(): boolean {
        return Utils.Devices.isMobile() || window.innerWidth < 768 || Utils.Devices.isIOS();
    }

    public handleMouseLeave($event: Event): void {
        this.isHovering = false;
        if (this.changeDetectorRef) {
            this.changeDetectorRef.markForCheck();
        }
    }

    public handleMouseEnter($event: Event): void {
        this.isHovering = true;
        if (this.changeDetectorRef) {
            this.changeDetectorRef.markForCheck();
        }
    }

    public lock(): void {
        this.isLocked = true;
        if (this.changeDetectorRef) {
            this.changeDetectorRef.markForCheck();
        }
        setTimeout(() => {
            this.isLocked = false;
            if (this.changeDetectorRef) {
                this.changeDetectorRef.markForCheck();
            }
        }, 100);
    }
}
